export default {
  jotform: {
    brandInfoFormId: "231583077748365",
    multiBrandInfoFormId: "223383466774062",
    materialFormId: "223053718495056",
    supplierFormId: "222981805960059"
  }
};
